module.exports = __webpack_public_path__ + "img/img_2.3a297478.png";